import MobileDetect from 'mobile-detect';

const inBrowser = typeof window !== 'undefined';
const getUserAgent = () => (inBrowser ? window.navigator.userAgent : '');
const getPlatform = () => (inBrowser ? window.navigator.platform : '');
const getMaxTouchPoints = () => (inBrowser ? window.navigator.maxTouchPoints : 0);
const getAppVersion = () => (inBrowser ? window.navigator.appVersion : '');
const getVendor = () => (inBrowser ? window.navigator.vendor : '');

const md = new MobileDetect(getUserAgent());

/**
 * Safari
 */

const isSafari = /^((?!chrome|android).)*safari/i.test(getUserAgent());
const iPadOS13Up = getPlatform() === 'MacIntel' && getMaxTouchPoints() > 1;
const isMac = getAppVersion().includes('Mac');
const isIOS = md ? md.os() === 'iOS' : false;

/**
 * Google
 */
const isAndroid = getUserAgent().includes('Android');
const isChrome = /Chrome/.test(getUserAgent()) && /Google Inc/.test(getVendor());

/**
 * Generic
 */
const isMobile = md ? md.mobile() !== null : false;
const isTablet = md ? md.tablet() !== null || iPadOS13Up : false;
const isTabletOrMobile = isTablet || isMobile;
const isMobilePhone = isMobile && !isTablet;

/**
 * Mozilla
 */
const isFirefox = getUserAgent().toLowerCase().includes('firefox');

/**
 * Microsoft
 */

const isIE = getUserAgent().includes('MSIE ') || getUserAgent().includes('Trident/'); // IE 10 || IE 11

const isEdge = getUserAgent().includes('Edge/'); // Edge (IE 12+)

// This only works on browsers:
export {
  iPadOS13Up,
  isAndroid,
  isChrome,
  isEdge,
  isFirefox,
  isIE,
  isIOS,
  isMac,
  isMobile,
  isMobilePhone,
  isSafari,
  isTablet,
  isTabletOrMobile,
};
